export const normalizarDocumento = (documento) => {
  if (!documento) return '';
  return documento.toString().trim().replace(/[./-]/g, '').toUpperCase();
};

export const formatarCnpjCpf = (documento) => {
  const documentoNormalizado = normalizarDocumento(documento);

  if (/^\d{11}$/.test(documentoNormalizado)) {
    return documentoNormalizado.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }

  if (/^[A-Z0-9]{12}\d{2}$/.test(documentoNormalizado)) {
    return documentoNormalizado.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  return documento || '';
};

export const validarCpf = (documento) => {
  const cpf = normalizarDocumento(documento);
  let soma = 0;
  let resto;

  if (!/^\d{11}$/.test(cpf) || cpf === '00000000000') {
    return false;
  }

  for (let i = 1; i <= 9; i += 1) soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10), 10)) return false;

  soma = 0;
  for (let i = 1; i <= 10; i += 1) soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;

  return resto === parseInt(cpf.substring(10, 11), 10);
};

const isValidCnpj = (cnpj) => {
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj) || cnpj === '00000000000000') {
    return false;
  }

  const dv1Informado = cnpj.charCodeAt(12) - 48;
  const dv2Informado = cnpj.charCodeAt(13) - 48;

  for (let j = 0; j < 2; j += 1) {
    let soma = 0;
    let peso = 2;
    const limite = cnpj.length - 2 + j;

    for (let i = limite - 1; i >= 0; i -= 1) {
      soma += (cnpj.charCodeAt(i) - 48) * peso;
      peso = (peso > 8) ? 2 : peso + 1;
    }

    let dv = 11 - (soma % 11);
    if (dv >= 10) dv = 0;

    if (j === 0 && dv !== dv1Informado) return false;
    if (j === 1 && dv !== dv2Informado) return false;
  }

  return true;
};

export const validarCnpj = (documento) => isValidCnpj(normalizarDocumento(documento));
